<template>
  <q-btn
    dense
    no-caps
    unelevated
    :loading="loading"
    type="submit"
    color="primary"
    :padding="loading ? '0' : '0 12px'"
    class="text-bold"
  >
    <span>{{ label }}</span>
    <template #loading>
      <q-spinner-ios size="xs" />
    </template>
  </q-btn>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    },

    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
